import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  CategoryItem,
  CategoryList,
  SideMenuContainer,
  LetterHeader,
  Count,
} from './CategorySideMenu.styles'
import { CategorySideMenuSkeleton } from './CategorySideMenuSkeleton'
import { UncontrolledCheckboxInput } from '@src/components/Inputs/CheckboxInput/CheckboxInput'

import { useCategories } from '@src/hooks/useCategories/useCategories'

export const CategorySideMenu: React.FC = () => {
  const { t } = useTranslation()
  const {
    topCategories,
    categoriesByFirstLetter,
    selectedCategories,
    toggleCategory,
  } = useCategories()

  const isLoading = Object.keys(categoriesByFirstLetter).length === 0

  return (
    <SideMenuContainer>
      {isLoading ? (
        <CategorySideMenuSkeleton />
      ) : (
        <>
          {topCategories.length > 0 && (
            <CategoryList>
              {topCategories.map(({ id, name }) => (
                <CategoryItem key={id}>
                  <UncontrolledCheckboxInput
                    name={`category-${id}`}
                    label={<CategoryLabel label={t(id)} />}
                    checked={selectedCategories.some(cat => cat.id === id)}
                    onChange={() => toggleCategory(name)}
                    size={18}
                  />
                </CategoryItem>
              ))}
            </CategoryList>
          )}

          {Object.entries(categoriesByFirstLetter).map(
            ([letter, categories]) => (
              <div key={letter}>
                <LetterHeader>{letter}</LetterHeader>
                <CategoryList>
                  {categories.map(({ id, name, outletCount }) => (
                    <CategoryItem key={id}>
                      <UncontrolledCheckboxInput
                        name={`category-${id}`}
                        label={
                          <CategoryLabel
                            label={name}
                            count={outletCount || 0}
                          />
                        }
                        checked={selectedCategories.some(cat => cat.id === id)}
                        onChange={() => toggleCategory(name)}
                        size={18}
                      />
                    </CategoryItem>
                  ))}
                </CategoryList>
              </div>
            )
          )}
        </>
      )}
    </SideMenuContainer>
  )
}

export const CategoryLabel: React.FC<{
  label: string
  count?: number
}> = ({ label, count }) => {
  return (
    <>
      {label}
      {count && <Count>{count}</Count>}
    </>
  )
}
